<template>
    <div class="table-card">
        <div class="table-header">
            <div class="row no-gutters">
                <div :class="{ 'col-5' : !hasBetColumn, 'col-4' : hasBetColumn }">
                    {{ "NAME" | translate }}
                </div>
                <div class="col-4">
                    {{ "SCORE" | translate }}
                </div>
                <div :class="{ 'col-3' : !hasBetColumn, 'col-2' : hasBetColumn }">
                    {{ "LEVEL" | translate }}
                </div>
                <div v-if="hasBetColumn" class="col-2">
                    {{ "BET" | translate }}
                </div>
            </div>
        </div>
        <div class="table-body">
            <div 
            v-for="(card, index) in cards" 
            @click="selectCard(card, $event)"
            :class="{ selected : card.selected, disabled : card.isLocked }"
            :key="index" 
            class="row no-gutters">

                <div :class="{ 'col-5' : !hasBetColumn, 'col-4' : hasBetColumn }">
                    {{ card.name }}
                </div>
                <div class="col-4">
                    {{ getCardScore(card) }}
                </div>
                <div :class="{ 'col-3' : !hasBetColumn, 'col-2' : hasBetColumn }">
                    {{ card.level }}
                </div>
                <div v-if="hasBetColumn" class="col-2">
                    <input v-if="!card.isLocked" type="radio" name="bet" :value="card.id" @change="onChange" class="bet-radio">
                    <input v-else type="radio" name="bet" disabled checked="false" class="bet-radio">
                </div>
            </div>

            <div v-if="cards.length <= 0" class="no-content">
                {{ "NO_CARDS" | translate }}
            </div>
        </div>
    </div>    
</template>

<script>
import { mapGetters } from "vuex";
import { getTeamScore, getCardScore } from '../util/transformDna';

export default {
    name: 'card-table',
    props: [ 'tableType', 'hasBetColumn', 'selectedBet', 'maxSelection' ],
    computed: {
        ...mapGetters({
            cards: 'getCards',          
            modalType: 'getModalType',
            selectedCards: 'getSelectedCards'
        })
    },
    methods: {
        onChange (e) {
            this.$emit('update', e.target.value);
        },
        selectCard (card, $event) {
            let elem = $event.target;
            
            if (elem.classList.contains('bet-radio')) return;
            if (card.isLocked) return;

            if (card.selected) {

                card.selected = false;
                for (let i=0; i<this.selectedCards.length; i++) {
                    if (card.id == this.selectedCards[i].id) {
                        this.selectedCards.splice(i, 1);
                        break;
                    }
                }

            } else {

                if (this.selectedCards.length >= this.maxSelection) {
                    this.$store.commit('removeFromSelectedCardsWithIndex', { index: 0 });
                }

                card.selected = true;

                // Add to selected cards array
                this.$store.commit('addToSelectedCards', card);
            }

            // Model is not updating
            // properly, so force it
            this.$forceUpdate();

        },
        getCardScore (card) {
            return getCardScore(card);
        }
    }
}
</script>

<style scoped lang="less">
@import "../assets/less/app.less";

.table-card {  
    border: 1px solid #ccc;

    .row {
        background: #000;
        color: #fff;
    }

    .table-header {
        border-bottom: 1px solid #efefef;
        
        [class|="col"] {
            padding: 10px;
            padding-left: 2px;  
        }
    }

    .table-body {
        max-height: 180px;
        overflow-y: scroll;
        text-transform: capitalize;

        .row:hover {
            cursor: pointer;
            background: #efefef;
            color: #000;                   
        }   

        .row.selected {     
            cursor: pointer;    
            background: #B9BBD6;
            color: #000;  
        }

        .row.disabled {
            background: red;
            cursor: default;

            &:hover {
                color: #fff;
            }
        }

        .row:not(:last-child) {
            border-bottom: 1px solid #ccc;
        }

        [class|="col"] {
            padding: 10px;
        }

        .no-content {
            font-size: 18px;
            padding-top: 70px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/CardTable.vue